import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import {
  Button,
  Divider,
  Container,
  Badge,
  Stack,
  Paper,
  Avatar,
  Menu as MenuMaterial,
  MenuItem,
  Typography,
} from "@mui/material";
import { Switch, FormControlLabel } from "@mui/material";
import Drawer from "./Drawer";
import Logo from "../imagens/logo.png";
import { useDispatch } from "react-redux";
import {
  usuarioLimparDados,
  usuarioNotificacoesMarcarLidaNaoLida,
} from "../redux/actions";
import { IconButton } from "@mui/material";
import Menu from "./Menu";
//
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BuildIcon from "@mui/icons-material/Build";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import NotificationsIcon from "@mui/icons-material/Notifications";

import { useHistory } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { RetornoEmBranco, Dialog, H6, Body1 } from ".";
import { useFetch } from "../hooks";

import Linkify from "linkify-react";
// Determina como gerar o elemento de link
const renderLink = ({ attributes, content }) => {
  const { href, ...props } = attributes;
  return (
    <p>
      <Button fullWidth variant="contained" size="small" href={href} {...props}>
        clicar aqui
      </Button>
    </p>
  );
};

// Componente que exibe as notificacoes
const VerNotificacoes = ({ fnFechar, notificacoes }) => {
  //

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1 }}>
      <Button variant="contained" size="small" fullWidth onClick={fnFechar}>
        FECHAR
      </Button>
      <Typography align="center" variant="h6">
        Notificações da aplicação
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {notificacoes?.length < 1 ? (
        <RetornoEmBranco />
      ) : (
        notificacoes?.map((ele) => (
          <ItemNotificacao key={ele.id_notificacao} {...ele} />
        ))
      )}
    </Container>
  );
};
// Componente para exibir o item de notificacao
const ItemNotificacao = ({ id_notificacao, data, mensagem, lida }) => {
  const dispatch = useDispatch();

  return (
    <Paper sx={{ p: 2 }}>
      <Stack>
        <ReactMarkdown children={mensagem} remarkPlugins={[remarkGfm]} />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <FormControlLabel
            onChange={(e) => {
              console.log(e.target.checked);
              if (e.target.checked) {
                dispatch(
                  usuarioNotificacoesMarcarLidaNaoLida({
                    id_notificacao,
                    lida: lida === "N" ? "S" : "N",
                  })
                );
              }
            }}
            control={<Switch />}
            label={`Marcar como ${lida === "N" ? "lida" : "não lida"}`}
          />
          <Typography variant="caption" color="secondary">
            Data: {format(parseISO(data), "dd/MM/yyyy HH:mm")}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
// Verifica se o usuario tem o app instalado
const DialogValidarAppInstalado = () => {
  const [verDialog, setVerDialog] = useState(null);
  const { error, setFetch } = useFetch("/verificar_app_instalado", "GET");
  useEffect(() => {
    setFetch({});
  }, [setFetch]);

  useEffect(() => {
    if (error) {
      setVerDialog(error);
    }
  }, [error, setVerDialog]);

  console.log(verDialog);

  return (
    <>
      {verDialog && (
        <Dialog
          sxContent={{ p: 0 }}
          comoSlide
          fecharDialogo={() => setVerDialog(null)}
          corpo={
            <Container maxWidth="xs">
              <H6>Informação importante</H6>
              <Divider sx={{ my: 1 }} />
              <Linkify
                as={Body1}
                options={{ target: "_blank", render: renderLink }}
              >
                {verDialog}
              </Linkify>
            </Container>
          }
        />
      )}
    </>
  );
};

const Header = ({ usuario, isMobile, isAdmin, handleDarkMode }) => {
  const [exibir, setExibir] = useState(null);
  // Ativa e desativa a exibicao das notificacoes
  const [verNotificacao, setVerNotificacao] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();

  const exibirSubMenu = (evt) => {
    setExibir(evt.currentTarget);
  };
  const ocultarSubMenu = () => {
    setExibir(null);
  };
  //
  const fnSair = () => {
    setExibir(null);
    window.location.href = "/logout";
    dispatch(usuarioLimparDados());
  };
  // Se ver notificacao estiver ativo
  let corpo;
  if (verNotificacao) {
    corpo = (
      <VerNotificacoes
        fnFechar={() => setVerNotificacao(null)}
        notificacoes={usuario?.notificacoes}
      />
    );
  }

  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        p: 0.4,
      }}
    >
      {usuario && <DialogValidarAppInstalado />}
      <img src={Logo} alt="Logo da empresa" height="36" />
      {/* Nao pode ser mobile e precisa tem o usuario autenticado */}
      {usuario && !isMobile && <Menu isAdmin={isAdmin} />}
      <Stack direction="row">
        {usuario && (
          <IconButton
            onClick={() => setVerNotificacao(true)}
            title="Notificações"
          >
            <Badge
              color="primary"
              badgeContent={
                usuario?.notificacoes?.length > 9
                  ? "+9"
                  : usuario?.notificacoes?.length
              }
            >
              <NotificationsIcon
                color={
                  usuario?.notificacoes?.length > 0 ? "primary" : "default"
                }
              />
            </Badge>
          </IconButton>
        )}
        <IconButton sx={{ mx: 1 }} onClick={handleDarkMode}>
          <Brightness4Icon />
        </IconButton>
        {usuario && (
          <>
            <Avatar
              title={`Avatar de ${usuario?.nome}`}
              alt={`Imagem de avatar ${usuario?.nome}`}
              src={usuario?.avatar || usuario?.nome?.substring(0, 1)}
            />
            <IconButton onClick={exibirSubMenu}>
              <MoreVertIcon />
            </IconButton>
          </>
        )}
      </Stack>
      <MenuMaterial
        open={Boolean(exibir)}
        onClose={ocultarSubMenu}
        anchorEl={exibir}
      >
        <MenuItem onClick={() => history.push("/configuracoes_do_usuario")}>
          <BuildIcon sx={{ mr: 0.5 }} />
          <Typography variant="body2">Configurações</Typography>
        </MenuItem>
        <MenuItem onClick={fnSair}>
          <ExitToAppIcon sx={{ mr: 0.5 }} />
          <Typography variant="body2">Sair</Typography>
        </MenuItem>
      </MenuMaterial>
      <Drawer
        anchor="right"
        corpo={corpo}
        fecharDrawer={() => setVerNotificacao(null)}
      />
    </Paper>
  );
};

export default Header;
